import { useDispatch, useSelector } from "react-redux";
import { getSensors } from "../../Api Methods/Api";
import { useEffect, useState } from "react";
import { Await } from "react-router-dom";
import PadlocksList from "../Padlocks/padlocksList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import StatCard from "../../components/UI/Stats/StatCard";
import mixpanel from "mixpanel-browser";

const TankSensors = () => {

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }

    const [sensors, setSensors] = useState([])
    const [linkedSensors, setLinkedSensors] = useState([])
    const [unlinkedSensors, setUnlinkedSensors] = useState([])
    const [criticalSensors, setCriticalSensors] = useState([])
    const [warningSensors, setWarningSensors] = useState([])
    const [healthySensors, setHealthySensors] = useState([])
    const [update, setUpdate] = useState(0)
    const filtering = ""
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const HandleGetTankSensors = async () => {
        //     const response = await getSensors(apiData, dispatch);
        //     const data = response.data[0]
        //     setSensors(data)
        //     console.log(data);
        //     setLinkedSensors(data.filter(s => s.uuid != null))
        //     setUnlinkedSensors(data.filter(s => s.uuid == null))
        //     setCriticalSensors(data.filter(s => s.battery != null && s.battery <= 5))
        //     setWarningSensors(data.filter(s => s.battery != null && s.battery > 5 && s.battery < 20))
        //     setHealthySensors(data.filter(s => s.battery != null && s.battery >= 20))
            setIsLoading(false)
        }

        HandleGetTankSensors();

        mixpanel.track("Tank Sensors tab visited", {
            user: localStorage.getItem('email')
        });
    }, [update])


    return (
        <Await resolve={sensors}>
            <div style={{ width: "100%" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 290px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
                    <StatCard title={"Sensors"} value={sensors.length} isLoading={isLoading} />
                    <StatCard title={"Linked sensors"} value={linkedSensors.length} isLoading={isLoading} />
                    <StatCard title={"Unlinked sensors"} value={unlinkedSensors.length} isLoading={isLoading} />
                    <StatCard title={"Critical (<5% battery)"} value={criticalSensors.length} isLoading={isLoading} />
                    <StatCard title={"Warning (<20% battery)"} value={warningSensors.length} isLoading={isLoading} />
                    <StatCard title={"Healthy (>20% battery)"} value={healthySensors.length} isLoading={isLoading} />
                </div>
                <br />
                {isLoading ? (
                    <div style={{ display: "flex", width: "100%" }}>
                        <DeviceLoadingGrid CardCount={20} />
                    </div>
                ) : (
                    <PadlocksList
                        locks={sensors}
                        filtering={filtering}
                        update={update}
                        setUpdate={setUpdate}
                        isSensors={true}
                    />
                )}
            </div>
        </Await>
    );
}


export default TankSensors;
